export const langArray = ['en', 'cs', 'de', 'es', 'pl']
export const itemArray = ['home']
export const phoneVisible = '0034 630 564 487'
export const phoneWhatsApp = '+34630564487'
export const phoneOld = '+447902459075'
export const email = 'jo.rudnik@gmail.com'
export const linkedinURL = 'https://www.linkedin.com/in/joannarudnik/'
export const facebookURL = 'https://www.facebook.com/elhierroguide'
export const instagramURL = 'https://www.instagram.com/elhierroguide/'
